<style scoped>
/* Cambia el tamaño del modal a Extra Grande */
::v-deep .modal-dialog {
    max-width: 80% !important; /* Puedes usar porcentajes o píxeles como 1200px */
}

/* Opcional: Centrar el modal verticalmente si se ve muy arriba */
::v-deep .modal-dialog {
    display: flex;
    align-items: center;
    min-height: calc(100% - 3.5rem);
}
</style>

<template>
    <div>
    <modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='dynamicUrl'>
                <div class="row">
                    <div class="form-group col align-items-left">
                        <label for="inputs_name" class="col-sm mb-0">
                            {{ $t('name') }}
                        </label>
                        <app-input id="inputs_name" class="col-sm" type="text" v-model="inputs.name"
                            :placeholder="$t('text_type_input')" :required="true" />
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="form-group col align-items-left">
                        <label class="col-sm mb-0">
                            {{ $t('search_and_select_p_category') }}
                        </label>
                        <app-input class="col-sm"  :placeholder="$t('search_and_select_p_category')" type="advance-search-select"
                                fetch-url="/productCategories/serverside/selectable-name" v-model="inputs.category"
                                listValueField="name" :loaded-per-time="5" />
                    </div>
                </div> -->

                <div class="row">
                    <div class="form-group row align-items-center ml-3">
                        <h4 class="col-md-8">
                            {{ $t('duty')  }} / {{  $t('add_tariff') }}
                        </h4>
                        <div class="col-12 row">
                            <div class="col-md-2 mr-0 pr-0"> <label> {{ $t('sub_category') }} </label></div>
                            <div class="col-md-2 mr-0 pr-0"> <label> {{ $t('country_of_origin') }} </label></div>
                            <div class="col-md-2 mr-0 pr-0"> <label> {{ $t('country_of_destination') }} </label></div>
                            <div class="col-md-2 mr-0 pr-0"> <label> {{ $t('hts_code') }} </label></div>
                            <div class="col-md-1 mr-0 pr-0"> <label> {{ $t('add_dutty') }} </label></div>
                            <div class="col-md-1 mr-0 pr-0"> <label> {{ $t('tariff') }} </label></div>
                        </div>
                        <div class="col-md-12">
                            <div v-for="(row, index) in rows " :key="index" class="row mb-2">
                                <SelectCustom :required="true" v-model="row.subCategory" divGridClass="col-md-2" :list="sub_categories" label="Sub category" />
                                <app-input
                                    class="col-md-2 mr-0 pr-0"
                                    :placeholder="$t('country_of_origin')"
                                    type="advance-search-select"
                                    fetch-url="/countries/serverside/selectable-name"
                                    v-model="row.countryFrom"
                                    listValueField="name"
                                    :loaded-per-time="5" :required="true"
                                />
                                <app-input
                                    class="col-md-2 mr-0 pr-0"
                                    :placeholder="$t('country_of_destination')"
                                    type="advance-search-select"
                                    fetch-url="/countries/serverside/selectable-name"
                                    v-model="row.countryTo"
                                    listValueField="name"
                                    :loaded-per-time="5" :required="true"
                                />
                                <app-input
                                    class="col-md-2 mr-0 pr-0"
                                    type="text"
                                    v-model="row.hts_code"
                                    :placeholder="$t('hts_code')"
                                    :disabled="false"
                                    :required="true"
                                />

                                <app-input
                                    class="col-md-1 mr-0 pr-0"
                                    type="number"
                                    v-model="row.dutyDisplay"
                                    :placeholder="$t('duty_rate')"
                                    :disabled="false"
                                    @focus="$event.target.select()"
                                />
                                <app-input
                                    class="col-md-1 mr-0 pr-0"
                                    type="number"
                                    v-model="row.tariffDisplay"
                                    :placeholder="$t('tariff')"
                                    :disabled="false"
                                />
                                <!-- <pre>{{ rows }}</pre> -->
                                <div class="col-md-2">
                                    <button v-if="index == 0"
                                        type="button"
                                        class= "btn btn-success"
                                        @click="addRow">+
                                    </button>
                                    <button v-if="index != 0"
                                        type="button"
                                        class= "btn btn-danger"
                                        @click="removeRow(index)">-
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-8">
                        <app-input type="custom-file-upload" :label="$t('upload_your_file')" v-model="inputs.image_url"
                            @change="onImageSelected"  />
                        <small class="text-muted font-italic">
                            {{ $t("recommended_custom_file_validation") }}
                        </small>
                    </div>



                <div class="form-group col align-items-center">
                    <label class="col-md-2 mb-md-0">
                        {{ $t('status') }}
                    </label>
                    <app-input  class="col-md-8 mt-2 pt-1"
                                type="radio"
                                :list="genderLists"
                                v-model="inputs.status"
                                :required="true"/>
                </div>
            </form>
        </template>
    </modal>
</div>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import SelectCustom from '../components/SelectCustom.vue';

export default {
    name: "AddProductModal",
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: String,
        modalTitle : String,
    },
    components : {
        SelectCustom
    },
    data() {
        return {
            sub_categories : [],
            rows : [
                {countryFrom : {
                    Code : null,
                    id : null,
                    name : null,
                },
                countryTo :{
                    Code : null,
                    id : null,
                    name : null,
                },
                subCategory : null,
                tariff:'',
                duty : 0,
                dutyDisplay : 0,
                tariffDisplay : 0,
                duty_number : '',
                hts_code : '',
                },
            ],
            preloader: false,
            inputs: {
                category: {
                    id: null,
                    name: null
                },
                status : '',
                tariff : null,
                image64: null
            },
            genderLists: [
                { id: 'active', value: "Active", },
                { id: 'inactive', value: "Inactive", },
            ],
            modalId: 'product-add-edit-modal',
            // modalTitle: this.$t('add'),
        }
    },
    created() {
        if (this.selectedUrl) {
            // this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
    computed: {
        dynamicUrl() {
            if (this.selectedUrl && this.inputs.id && this.modalTitle === 'Edit') {
                return `products/${this.inputs.id}`;
            } else if (this.selectedUrl) {
                return 'products';
            } else {
                return 'products';
            }
        }
    },
    watch: {
        rows: {
            deep: true,
                handler(newRows) {
                    newRows.forEach(row => {
                        let num = parseFloat(row.dutyDisplay);
                        row.duty = isNaN(num) ? 0 : num;

                        num = parseFloat(row.tariffDisplay);
                        row.tariff = isNaN(num) ? 0 : num;
                    });
                }
        }
    },
    methods: {
         async get_data_customTable (customTable) {
            this.preloader = true;
            let obj = {};
            let array = [];
            try {
                // se debe consultar por el nombre para encontrar el id
                const resId = await axios.get(`/admin/app/custom-table/serverside/id/${customTable}`);
                if (resId.data.id) {
                    const response = await axios.get(`/admin/app/custom-table/values/${resId.data.id}`);
                    const dataRes = response.data.data;
                    for (let index = 0; index < dataRes.length; index++) {
                        const element = dataRes[index]['field_values'];
                        for (let y = 0; y < element.length; y++) {
                            if (y == 0) {
                                obj = {'id' : element[y]['id'], 'value' : element[y]['value']};
                                array.push(obj);
                            }
                        }
                    }
                    return array;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
            this.preloader= false;
        },
        async getTariff() {
            try {
                this.preloader = true;
                const response = await axios.get(`/getTariff/${this.selectedUrl}`);
                const data = response.data;
                if (data.length > 0) {
                    this.rows = [];
                    for (const item of data){
                        let obj = {
                            subCategory : {
                                id : item.subcategory_id,
                                value : item.subcategory_value
                            },
                            countryFrom : {
                                Code : item.tariff_from[0].Code,
                                id : item.tariff_from[0].id,
                                name : item.tariff_from[0].name,
                            },
                            countryTo : {
                                Code : item.tariff_to[0].Code,
                                id : item.tariff_to[0].id,
                                name : item.tariff_to[0].name,
                            },
                            tariff:item.tariff,
                            duty: Math.floor(item.duty_rate*100),
                            dutyDisplay :item.duty_number,
                            tariffDisplay : item.tariff,
                            duty_number : item.duty_number,
                            hts_code : item.hts_code,
                        }
                        this.rows.push(obj);
                    }
                }
                this.preloader = false;
            } catch (error) {
                console.error('Error fetching tariffs:', error);
            }
        },

        addRow(){
            this.rows.push({ countryFrom:'', countryTo:'', tariff:'', duty:'', hts_code:'', dutyDisplay:0, tariffDisplay:0})
        },

        removeRow(index){
            this.rows.splice(index, 1)
        },

        onImageSelected(event) {

        const file = event.target.files[0]; // Obtén el archivo seleccionado
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.inputs.image_url = reader.result
                this.inputs.image64 = reader.result
            };
            reader.readAsDataURL(file); // Lee la imagen como URL base64
        } else {
            this.inputs.image_url = null; // Reinicia si no se selecciona un archivo
        }
    },

        submit() {
            if (!this.inputs.name) {
                this.$toastr.e(this.$t('Complete_the_name'));
                return;
            }

            const rows = this.rows;
            let flagError = false;
            rows.forEach(element => {
                if (!element.subCategory) {
                    this.$toastr.e(this.$t('Subcategory_required'));
                    flagError = true;
                    return;
                }
            
                if (element.countryFrom === '') {
                    this.$toastr.e(this.$t('Country of Origin is required'));
                    flagError = true;
                    return;
                }

                if (element.countryTo === '') {
                    this.$toastr.e(this.$t('Country of Destination is required'));
                    flagError = true;
                    return;
                }

                if (element.hts_code === '') {
                    this.$toastr.e(this.$t('HTS Code is required'));
                    flagError = true;
                    return;
                }
                    
            });

            if(flagError) return;

            this.inputs.tariff = this.rows;
            // console.log(this.inputs);
            if (this.modalTitle === 'Add') {
                this.selectedUrl = false;
            }

             this.save(this.inputs);
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData(response) {
            if (response.data.phone) this.phone = response.data.phone;
            this.inputs = response.data;
            this.preloader = false;
        },
    },
    async mounted() {
        this.sub_categories = await this.get_data_customTable('sub_category');
        this.getTariff();
    }
}
</script>
